import { ArrowLeft, X, ChevronLeft, ChevronRight } from "lucide-react";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import * as api from "../api/api";
import "./GalleryPage.css";

const GalleryPage = () => {
  const { locationSlug } = useParams();
  const navigate = useNavigate();
  const [selectedImage, setSelectedImage] = React.useState(null);

  const [location, setLocation] = React.useState(null);
  const [gallery, setGallery] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  // Navigation functions for lightbox
  const goToPrevious = () => {
    const currentIndex = gallery.findIndex(img => img.id === selectedImage.id);
    const prevIndex = currentIndex === 0 ? gallery.length - 1 : currentIndex - 1;
    setSelectedImage(gallery[prevIndex]);
  };

  const goToNext = () => {
    const currentIndex = gallery.findIndex(img => img.id === selectedImage.id);
    const nextIndex = currentIndex === gallery.length - 1 ? 0 : currentIndex + 1;
    setSelectedImage(gallery[nextIndex]);
  };

  React.useEffect(() => {
    let mounted = true;
    const load = async () => {
      try {
        const locs = await api.getLocations();
        const found = locs.find((l) => l.slug === locationSlug);
        if (mounted && found) setLocation(found);
      } catch (err) {
        console.warn("Failed to fetch locations, using mock", err);
      }

      try {
        const res = await api.getGallery(locationSlug);
        if (mounted && res) setGallery(res);
      } catch (err) {
        console.warn("Failed to fetch gallery, using mock", err);
      } finally {
        if (mounted) setLoading(false);
      }
    };
    load();
    return () => {
      mounted = false;
    };
  }, [locationSlug]);

  if (!location) {
    return <div>Location not found</div>;
  }

  return (
    <div className="gallery-page">
      {/* Navigation Header */}
      <div className="page-header">
        <div className="container">
          <button
            className="back-btn"
            onClick={() => navigate(`/${locationSlug}`)}
          >
            <ArrowLeft size={20} /> Retour
          </button>
          <h1 className="heading-lg">Galerie Photos</h1>
          <p
            className="body-lg"
            style={{ color: "var(--text-secondary)", marginTop: "1rem" }}
          >
            Découvrez nos locaux modernes et équipés
          </p>
        </div>
      </div>

      {/* Gallery Grid */}
      <section className="section">
        <div className="container">
          <div className="gallery-grid">
            {gallery.map((image) => (
              <div
                key={image.id}
                className="gallery-item"
                onClick={() => setSelectedImage(image)}
              >
                <img src={image.url} alt={image.alt} />
                <div className="gallery-overlay">
                  <span>Voir en grand</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Image Lightbox */}
      {selectedImage && (
        <div
          className="lightbox-overlay"
          onClick={() => setSelectedImage(null)}
        >
          <button
            className="lightbox-close"
            onClick={() => setSelectedImage(null)}
          >
            <X size={32} />
          </button>
          
          <button
            className="lightbox-nav lightbox-prev"
            onClick={(e) => {
              e.stopPropagation();
              goToPrevious();
            }}
          >
            <ChevronLeft size={40} />
          </button>

          <button
            className="lightbox-nav lightbox-next"
            onClick={(e) => {
              e.stopPropagation();
              goToNext();
            }}
          >
            <ChevronRight size={40} />
          </button>

          <div
            className="lightbox-content"
            onClick={(e) => e.stopPropagation()}
          >
            <img src={selectedImage.url} alt={selectedImage.alt} />
          </div>
        </div>
      )}
    </div>
  );
};

export default GalleryPage;
